import { Component, OnInit, ChangeDetectionStrategy, ViewChild, TemplateRef, ChangeDetectorRef } from '@angular/core';

import { CDSMask } from '@app/utils/cds-mask';
import { ActivatedRoute } from '@angular/router';
import { MinhaAgenda } from '@app/models/minha-agenda';
import { MinhaAgendaService } from '@app/services/minha-agenda.service';

import { CalendarEvent, CalendarEventTimesChangedEvent } from 'angular-calendar';
import { Subject } from 'rxjs';

import { Funcionario } from '@app/models/funcionario';
import { IdDescricao } from '@app/models/util/id-descricao';

// import { CompleterItem } from 'ng2-completer';
// import { AutocompleteDataService } from '@app/services/autocomplete.service';
import { ParticipanteService } from '@app/services/participante.service';
import { UtilitarioService } from '@app/services/utilitario.service';
import { ConsultasService } from '@app/services/consultas.service';
import { UsuarioService } from '@app/services/usuario.service';
import {
  isSameMonth,
  isSameDay,
  startOfMonth,
  endOfMonth,
  startOfWeek,
  endOfWeek,
  startOfDay,
  endOfDay,
  format
} from 'date-fns';
import { BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-atendimento-lista',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './atendimento-lista.component.html'
})
export class AtendimentoListaComponent implements OnInit {
  lstMinhaAgenda: MinhaAgenda[];
  events: CalendarEvent[] = [];
  activeDayIsOpen = false;
  dataHoje = new Date();
  minhaAgenda: MinhaAgenda = new MinhaAgenda();
  cdsMask: CDSMask = new CDSMask();
  lstErros: string[];
  // clienteDataService: AutocompleteDataService;
  // advogadoDataService: AutocompleteDataService;
  participanteNome: string;
  lstMinhaAgendaDiaSelecionado: MinhaAgenda[];
  buscarAgendaDeOutroUsuarioId;
  lstAdvogados: Funcionario[];
  lstUnidades: IdDescricao[] = [];
  mostrarApenasDia = true;

  colors: any = {
    red: {
      primary: '#ad2121',
      secondary: '#FAE3E3'
    },
    blue: {
      primary: '#1e90ff',
      secondary: '#D1E8FF'
    },
    yellow: {
      primary: '#e3bc08',
      secondary: '#FDF1BA'
    }
  };

  constructor(private minhaAgendaService: MinhaAgendaService,
    private modal: BsModalService,
    private route: ActivatedRoute,
    private participanteService: ParticipanteService,
    private consultasService: ConsultasService,
    private usuarioService: UsuarioService,
    private cdr: ChangeDetectorRef
  ) {
  }

  // calendario
  @ViewChild('modalContent', { static: true }) modalContent: TemplateRef<any>;

  view: 'month' | 'week' | 'day' = 'day';

  viewDate: Date = new Date();

  modalData: {
    action: string;
    event: CalendarEvent;
  };

  refresh: Subject<any> = new Subject();

  dayClicked({ date, events }: { date: Date; events: CalendarEvent[] }): void {
    if (isSameMonth(date, this.viewDate)) {
      if ((isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) || events.length === 0) {
        this.activeDayIsOpen = false;
      } else {
        this.activeDayIsOpen = true;
        this.viewDate = date;
      }
    }
    this.alterarAgendaDoDiaSelecionado(UtilitarioService.retornaDataISO(date));
    // this.alterarAgendaDoDiaSelecionado(date.toISOString().split('T')[0]);
  }

  eventTimesChanged({
    event,
    newStart,
    newEnd
  }: CalendarEventTimesChangedEvent): void {
    event.start = newStart;
    event.end = newEnd;
    this.handleEvent('Dropped or resized', event);
    this.refresh.next();
  }

  handleEvent(action: string, event: CalendarEvent): void {
    this.modalData = { event, action };
    this.modal.show(this.modalContent);
  }

  ngOnInit() {
    // this.obterAdvogados();
    const hoje = new Date();
    const horas = UtilitarioService.adicionaZero(hoje.getHours());
    const horaFinal = UtilitarioService.adicionaZero(hoje.getHours() + 1);
    const minutos = UtilitarioService.adicionaZero(hoje.getMinutes());

    this.minhaAgenda.DataAgendada = hoje.toLocaleDateString();
    this.minhaAgenda.HoraInicioAgendada = horas + ':' + minutos;
    this.minhaAgenda.UsuarioId = 0;
    this.obterTodosOnInit('', '');

    this.consultasService.consultar('UNIDADE_S_RATEIO').toPromise().then(data => this.lstUnidades = data);

    this.usuarioService.obterUsuarioLogado().toPromise().then(data => {
      this.buscarAgendaDeOutroUsuarioId = data;
      this.consultasService.consultar('USUARIO_APELIDO_E_NOMEFANTASIA').toPromise().then(usuarios => {
        const atendimentoOutroUsuarioid = window.sessionStorage.getItem('atendimentoOutroUsuarioid');

        if (atendimentoOutroUsuarioid && atendimentoOutroUsuarioid !== '') {
          this.buscarAgendaDeOutroUsuarioId = parseInt(atendimentoOutroUsuarioid, 10);
          this.obterTodos('', '');
        } else {
          this.obterTodos('', '');
        }

        this.obterTodos('', '');

        this.lstAdvogados = usuarios;
        this.refresh.next();
      });
    });


    // this.consultasService.consultar("USUARIO").then(data => {
    //   let atendimentoOutroUsuarioid = window.sessionStorage.getItem('atendimentoOutroUsuarioid');
    //   if (atendimentoOutroUsuarioid != null) {
    //     this.buscarAgendaDeOutroUsuarioId = atendimentoOutroUsuarioid;
    //     this.obterTodos(this.buscarAgendaDeOutroUsuarioId);
    //   } else
    //     this.obterTodos();

    //   this.lstAdvogados = data;
    //   this.refresh.next();
    // });

    this.route.params.subscribe(
      (params: any) => {
        const id = params['id'];
        if (id != null && id > 0) {
          this.participanteService.obterPorId(id).toPromise().then((data) => {
            if (data != null) {
              this.minhaAgenda.ClienteId = id;
              this.participanteNome = data.NomeFantasia;
              this.refresh.next();

            }
          });
        }
      });

  }

  obterTodos(dataInicial: string, dataFinal: string) {
    this.minhaAgenda.Descricao = '';
    this.minhaAgendaService.obterAtendimento(this.buscarAgendaDeOutroUsuarioId, Number.parseInt(this.minhaAgenda.UnidadeId as string, 10), this.view, dataInicial, dataFinal)
      .toPromise().then(data => {
        this.lstMinhaAgenda = data;
        this.alterarAgendaDiaSelecionaAnteriorProximo();
        this.events = [];
        for (let i = 0; i < this.lstMinhaAgenda.length; i++) {
          const minhaAgenda = this.lstMinhaAgenda[i];
          let HoraInicioAgendada;

          if (!minhaAgenda.HoraInicioAgendada) {
            minhaAgenda.HoraInicioAgendada = '00:00';
          }

          HoraInicioAgendada = minhaAgenda.HoraInicioAgendada.split(':');

          const dataAgendada = minhaAgenda.DataAgendada.split('T')[0].split('-');

          const dd = parseInt(dataAgendada[2], 10);
          const mm = parseInt(dataAgendada[1], 10);
          const yyyy = parseInt(dataAgendada[0], 10);
          const audiencia = minhaAgenda.Audiencia ? ' (AUDIÊNCIA) ' : '';
          const cancelado = minhaAgenda.Cancelado ? ' <strong style="color:red!important;">(CANCELADO)</strong>' : '';
          const realizado1 = minhaAgenda.Realizado ? '<strike>' : '';
          const realizado2 = minhaAgenda.Realizado ? '</strike>' : '';
          if (new Date(yyyy, mm, dd).toISOString().split('T')[0] === this.dataHoje.toISOString().split('T')[0]) {
            this.activeDayIsOpen = true;
          }
          minhaAgenda.ClienteNome = minhaAgenda.ClienteNome == null ? 'Sem Cliente' : minhaAgenda.ClienteNome;
          this.events.push({
            title: realizado1 + '<strong>' + minhaAgenda.HoraInicioAgendada + audiencia + '</strong>' + ' - ' + minhaAgenda.ClienteNome + ' - ' + minhaAgenda.Descricao + cancelado + realizado2,
            start: new Date(yyyy, mm - 1, dd, Number.parseInt(HoraInicioAgendada[0], 10), Number.parseInt(HoraInicioAgendada[1], 10), 0),
            end: new Date(yyyy, mm - 1, dd, Number.parseInt(HoraInicioAgendada[0], 10) + 1, Number.parseInt(HoraInicioAgendada[1], 10), 0),
            color: minhaAgenda.Cancelado ? this.colors.red : minhaAgenda.EmDestaque ? this.colors.yellow : this.colors.blue,
            draggable: false,
            resizable: {
              beforeStart: true,
              afterEnd: true
            },
            actions:
              [
                {
                  label: '<i class="fa fa-fw fa-pencil"></i>',
                  onClick: ({ event }: { event: CalendarEvent }): void => {
                    window.location.href = '#/agenda/minha-agenda/editar/' + minhaAgenda.Id;
                  }
                }
              ]
          });
        }
        this.refresh.next();
      }
      );
  }
  obterTodosOnInit(dataInicial: string, dataFinal: string) {
    this.minhaAgenda.Descricao = '';
    let data = new Date();
    dataInicial = UtilitarioService.retornaDataISO(data);
    dataFinal = UtilitarioService.retornaDataISO(data);

    this.minhaAgendaService.obterAtendimento(this.buscarAgendaDeOutroUsuarioId, null, this.view, dataInicial, dataFinal)
      .toPromise().then(data => {
        this.lstMinhaAgenda = data;
        this.alterarAgendaDiaSelecionaAnteriorProximo();
        this.events = [];
        for (let i = 0; i < this.lstMinhaAgenda.length; i++) {
          const minhaAgenda = this.lstMinhaAgenda[i];
          let HoraInicioAgendada;

          if (!minhaAgenda.HoraInicioAgendada) {
            minhaAgenda.HoraInicioAgendada = '00:00';
          }

          HoraInicioAgendada = minhaAgenda.HoraInicioAgendada.split(':');

          const dataAgendada = minhaAgenda.DataAgendada.split('T')[0].split('-');

          const dd = parseInt(dataAgendada[2], 10);
          const mm = parseInt(dataAgendada[1], 10);
          const yyyy = parseInt(dataAgendada[0], 10);
          const audiencia = minhaAgenda.Audiencia ? ' (AUDIÊNCIA) ' : '';
          const cancelado = minhaAgenda.Cancelado ? ' <strong style="color:red!important;">(CANCELADO)</strong>' : '';
          const realizado1 = minhaAgenda.Realizado ? '<strike>' : '';
          const realizado2 = minhaAgenda.Realizado ? '</strike>' : '';
          if (new Date(yyyy, mm, dd).toISOString().split('T')[0] === this.dataHoje.toISOString().split('T')[0]) {
            this.activeDayIsOpen = true;
          }
          minhaAgenda.ClienteNome = minhaAgenda.ClienteNome == null ? 'Sem Cliente' : minhaAgenda.ClienteNome;
          this.events.push({
            title: realizado1 + '<strong>' + minhaAgenda.HoraInicioAgendada + audiencia + '</strong>' + ' - ' + minhaAgenda.ClienteNome + ' - ' + minhaAgenda.Descricao + cancelado + realizado2,
            start: new Date(yyyy, mm - 1, dd, Number.parseInt(HoraInicioAgendada[0], 10), Number.parseInt(HoraInicioAgendada[1], 10), 0),
            end: new Date(yyyy, mm - 1, dd, Number.parseInt(HoraInicioAgendada[0], 10) + 1, Number.parseInt(HoraInicioAgendada[1], 10), 0),
            color: minhaAgenda.Cancelado ? this.colors.red : minhaAgenda.EmDestaque ? this.colors.yellow : this.colors.blue,
            draggable: false,
            resizable: {
              beforeStart: true,
              afterEnd: true
            },
            actions:
              [
                {
                  label: '<i class="fa fa-fw fa-pencil"></i>',
                  onClick: ({ event }: { event: CalendarEvent }): void => {
                    window.location.href = '#/agenda/minha-agenda/editar/' + minhaAgenda.Id;
                  }
                }
              ]
          });
        }
        this.refresh.next();
      }
      );
  }
  alterarAgendaDoDiaSelecionado(dataSelecionada: string) {
    this.lstMinhaAgendaDiaSelecionado = this.lstMinhaAgenda.filter(x => x.DataAgendada.split('T')[0] === dataSelecionada);
  }
  alterarAgendaDiaSelecionaAnteriorProximo() {

    this.alterarAgendaDoDiaSelecionado(UtilitarioService.retornaDataISO(this.viewDate));
  }

  aoSelecionarAdvogado() {
    if (this.buscarAgendaDeOutroUsuarioId) {
      this.minhaAgenda.UnidadeId = null;
      this.cdr.detectChanges();
      this.alteraAgenda();
    }
  }

  aoSelecionarUnidade() {
    if (this.minhaAgenda.UnidadeId) {
      this.buscarAgendaDeOutroUsuarioId = null;
      this.cdr.detectChanges();
      this.alteraAgenda();
    }
  }

  isAdvogadoPreenchido(): boolean {
    return !!this.buscarAgendaDeOutroUsuarioId;
  }

  isUnidadePreenchida(): boolean {
    return !!this.minhaAgenda.UnidadeId;
  }

  alteraAgenda() {
    window.sessionStorage.removeItem('atendimentoOutroUsuarioid');
    window.sessionStorage.setItem('atendimentoOutroUsuarioid', this.buscarAgendaDeOutroUsuarioId);
    this.obterTodos('', '');
  }

  deletar(id: number) {
    this.minhaAgendaService.deletarAtendimento(id).subscribe((data) => {
      this.fechaInformacoes();
      this.obterTodos('', '');
    });
  }

  fechaInformacoes() {
    this.activeDayIsOpen = false;
  }

  // selecionaCliente(selected: CompleterItem) {
  //   if (selected) {
  //     this.minhaAgenda.ClienteId = selected.originalObject.Id;
  //   }
  // }
  // selecionaAdvogado(selected: CompleterItem) {
  //   if (selected) {
  //     this.minhaAgenda.UsuarioId = selected.originalObject.Id;
  //   }
  // }

  cancelar(atendimentoid: number) {
    this.minhaAgendaService.cancelarAtendimento(atendimentoid).subscribe(
      () => { this.alteraAgenda(); }
    );
  }

  iniciar(atendimentoid: number) {
    this.minhaAgendaService.iniciarAtendimento(atendimentoid).subscribe(
      () => { this.alteraAgenda(); }
    );
  }

  finalizar(atendimentoid: number) {
    this.minhaAgendaService.finalizarAtendimento(atendimentoid).subscribe(
      () => { this.alteraAgenda(); }
    );
  }


  viewDateChange(type: 'month' | 'week' | 'day' | '') {

    if (type) {
      this.view = type;
    }

    const getStart: any = {
      month: startOfMonth,
      week: startOfWeek,
      day: startOfDay
    }[this.view];

    const getEnd: any = {
      month: endOfMonth,
      week: endOfWeek,
      day: endOfDay
    }[this.view];


    const dataInicial = format(getStart(this.viewDate), 'yyyy-MM-dd');
    const dataFinal = format(getEnd(this.viewDate), 'yyyy-MM-dd');

    this.obterTodos(dataInicial, dataFinal);
    this.activeDayIsOpen = false;

  }


}
